export const GET_HAPPINESS_TIPS = "GET_HAPPINESS_TIPS";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
